// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"445":"1bfc9850","609":"31664189","678":"component---src-pages-index-js","774":"framework"}[chunkId] || chunkId) + "-" + {"223":"15e2eaa958a37b457710","231":"d35cd4a5b967eb6d4f66","445":"086a4e677784548923ba","609":"b9019f276faf8c0ea948","678":"ec4c0b394e0967fc3e89","774":"eb20c115762bcb976626"}[chunkId] + ".js";
};